import { Chart } from 'chart.js';
import ChartDeferred from 'chartjs-plugin-deferred';

import { Component, Element, h, Host, Prop, State, Watch } from '@stencil/core';

import { chartCfg, dataSetProps } from './pn-chart-helper';

@Component({
  tag: 'pn-chart',
  styleUrl: 'pn-chart.scss',
})
export class PnChart {
  @Element() element: HTMLElement;
  @Prop() labels: string = null;
  @Prop() dataSets: string = null;
  @Prop() dataChartType: any = 'doughnut';

  @State() myChartCtxRef: any;

  myChart: any;
  parsedDataSets: any;
  parsedLabels: string[];
  parsedDatasetWithDataParsed: any;
  data: any;
  numberOfSetsGreaterThanOne: boolean;

  @Watch('dataSets')
  dataChangeHandler() {
    this.parsedDataSets = JSON.parse(this.dataSets);
    this.numberOfSetsGreaterThanOne = this.parsedDataSets.length > 1;
    this.parsedDatasetWithDataParsed = this.parsedDataSets.map(set => dataSetProps(set, this.dataChartType));
    this.data = {
      ...this.data,
      datasets: this.parsedDatasetWithDataParsed,
    };
  }

  @Watch('labels')
  labelsChangeHandler() {
    this.parsedLabels = JSON.parse(this.labels) as string[];
    this.data = {
      ...this.data,
      labels: this.parsedLabels,
    };
  }

  componentWillLoad() {
    this.dataChangeHandler();
    this.labelsChangeHandler();
  }

  componentDidLoad() {
    Chart.plugins.register(ChartDeferred);
    this.myChartCtxRef = this.element.querySelector('#chart-canvas');
    this.myChart = new Chart(this.myChartCtxRef, chartCfg(this.dataChartType, this.data, this.numberOfSetsGreaterThanOne));
  }

  render() {
    return (
      <Host>
        <div class="chart-wrapper">
          <canvas id="chart-canvas" class="pnChart"></canvas>
        </div>
      </Host>
    );
  }
}
